// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"da17786fce62ae6d6907","397":"8c9743937fb599ef7fe6"}[chunkId] + ".bundle.js";
};